import { ProjectTimelinesActionType } from '../actionTypes/projectTimelines';
import { ProjectTimeline } from '../types';

const reducer = (
    state: Array<ProjectTimeline> = [],
    action: {
        type: string;
        payload: Array<ProjectTimeline>;
    },
) => {
    switch (action.type) {
        case ProjectTimelinesActionType.GET_TIMELINES_BY_USERID:
            return action.payload;
        case ProjectTimelinesActionType.GET_ALL_PROJECT_TIMELINE:
            return action.payload;
        case ProjectTimelinesActionType.CREATE_PROJECT_TIMELINE:
            return [...state, action.payload];
        case ProjectTimelinesActionType.UPDATE_PROJECT_TIMELINE:
            return [...state];
        case ProjectTimelinesActionType.DELETE_PROJECT_TIMELINE: {
            return state.filter((timeline: ProjectTimeline) => {
                return action.payload.find(
                    (deletedTimeline) =>
                        timeline._id?.toString() !==
                        deletedTimeline._id?.toString(),
                );
            });
        }
        default:
            return state;
    }
};

export default reducer;
